import React, { useState, useEffect } from "react";
import cx from "classnames";
import { css } from "react-emotion";
import { Transition } from "react-transition-group";

const container = css`
  position: relative;
  height: 15rem;
  margin-bottom: 2rem;
  width: 100%;
  text-align: center;
`;
const imageStyle = css`
  width: 100%;
  height: 100%;
  transition: 0.4s;
  object-fit: cover;
`;

const enteringImage = css`
  transform: translate(3rem);
  opacity: 0;
  transition: 0.4s;
`;

const exitingImage = css`
  transform: translate(-3rem);
  opacity: 0;
`;

function RotatingGalleryWebComponent(props) {
  const { images } = props;
  // console.log(images);
  const [state, setState] = useState({ activeIdx: 0, inTransition: false });
  const activeImage = images[state.activeIdx];

  useEffect(() => {
    if (images.length > 1) setTimeout(updateImage, 3000);
  }, []);

  const updateImage = () => {
    const { images } = props;
    const maxIdx = images.length - 1;
    setState((prevState) => ({
      ...prevState,
      inTransition: true,
    }));
    let timer = setTimeout(() => {
      setState((prevState) => {
        let newIdx = prevState.activeIdx + 1;
        if (newIdx > maxIdx) newIdx = 0;
        return { activeIdx: newIdx, inTransition: false };
      });
      timer = setTimeout(updateImage, 3000);
    }, 500);
  };

  return (
    <div className={container}>
      {activeImage && images.length > 1 && (
        <Transition in={!state.inTransition} timeout={420} unmountOnExit>
          {(state) => (
            <img
              src={activeImage.url}
              className={cx(
                imageStyle,
                state === "exiting" && exitingImage,
                state === "entering" && enteringImage
              )}
            />
          )}
        </Transition>
      )}
      {activeImage && images.length === 1 && (
        <img src={activeImage.url} className={imageStyle} />
      )}
    </div>
  );
}

export default RotatingGalleryWebComponent;
